import {memo} from 'react';

import styled from 'styled-components';

import {FlexCenter} from '~/shared/theme/FlexLayout';
import {media} from '~/shared/theme/media';
import {getLocalizationService} from '~/shared/services/localisationService';
import {headingS} from '~/shared/theme/typography';

import EmptyStateImage from './assets/noBenefits.svg?react';

const Root = styled(FlexCenter)`
  flex-direction: column;
  padding: 48px 0;
  gap: 24px;
  ${media.minLargeTablet`
    padding: 56px 0;
  `}
`;

const Label = styled.p`
  ${headingS}
  color: ${({theme}) => theme.colors.charcoal80};
  text-align: center;
`;

const StyledEmptyStateImage = styled(EmptyStateImage)`
  width: 180px;
  height: 180px;
  ${media.minLargeMobile`
    width: 200px;
    height: 200px;
  `}
`;

const EmptyState = () => {
  const {t} = getLocalizationService();

  return (
    <Root data-test-id="noBenefitsEmptyState">
      <StyledEmptyStateImage viewBox="0 0 200 200"/>
      <Label>
        {t('you_dont_have_any_benefits_at_this_time')}
      </Label>
    </Root>
  );
};

export default memo(EmptyState);
